import { useState, useEffect } from 'react';

export const useBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock data - replace with API call
    setTimeout(() => {
      setBookings([
        {
          id: 'BK001',
          date: new Date().toISOString(),
          time: '10:00',
          serviceName: 'Installation Service',
          customerName: 'Jane Smith',
          email: 'jane@example.com',
          phone: '+44 20 9876 5432',
          postcode: 'SW1A 1AA',
          status: 'confirmed',
        },
      ]);
      setLoading(false);
    }, 500);
  }, []);

  const updateBookingStatus = async (bookingId, status) => {
    setBookings((prev) =>
      prev.map((booking) =>
        booking.id === bookingId ? { ...booking, status } : booking
      )
    );
  };

  return { bookings, loading, updateBookingStatus };
};

